import React, { useState } from 'react';
import { marketplaceApi } from '../../api/marketplace';
import { useLanguage } from '../../i18n/LanguageContext';

const CounterOfferCard = ({ counterOffer, user, onUpdated, onError }) => {
  const { t, locale } = useLanguage();
  const [processing, setProcessing] = useState(false);

  const handleAcceptCounterOffer = async () => {
    if (!user?.id) return;
    setProcessing(true);
    try {
      await marketplaceApi.acceptCounterOffer(counterOffer.id, user.id);
      onUpdated();
      onError(`✅ ${t('trade.counterOfferTitle')} ${t('trade.accept').toLowerCase()}.`);
    } catch (error) {
      onError(`❌ ${error.message || t('trade.acceptFailed')}`);
    } finally {
      setProcessing(false);
    }
  };

  const handleRejectCounterOffer = async () => {
    if (!user?.id) return;
    setProcessing(true);
    try {
      await marketplaceApi.rejectCounterOffer(counterOffer.id, user.id);
      onUpdated();
      onError(`✅ ${t('marketplace.tradeRejectSuccess')}`);
    } catch (error) {
      onError(`❌ ${error.message || t('trade.rejectFailed')}`);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="football-card glass-football p-6 border-2 border-yellow-500/30">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-xl font-bold text-[#1e293b] mb-2">
            {t('trade.counterOfferTitle')} - {t('trade.byUser', { username: counterOffer.userUsername })}
          </h3>
          <p className="text-sm text-gray-400">
            {t('trade.openTrade')} • {new Date(counterOffer.createdAt).toLocaleDateString(locale || 'it-IT')}
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mb-4">
        <div className="p-4 bg-blue-500/10 border-2 border-blue-500/30 rounded-lg">
          <p className="text-sm text-gray-400 mb-1">{t('trade.theyOffer')}:</p>
          <p className="font-semibold text-white">{counterOffer.trade?.card1?.playerName || t('trade.unknownPlayer')}</p>
          <p className="text-xs text-gray-400">{counterOffer.trade?.card1?.rarity || t('trade.unknownRarity')}</p>
          <p className="text-xs text-gray-400 mt-2">
            {t('trade.youWant')}: {counterOffer.trade?.desiredPlayer?.name || t('common.unknown')} ({counterOffer.trade?.desiredRarity || t('common.unknown')})
          </p>
        </div>
        <div className="p-4 bg-yellow-500/10 border-2 border-yellow-500/30 rounded-lg">
          <p className="text-sm text-gray-400 mb-1">{t('trade.theyOffer')}:</p>
          <p className="font-semibold text-white">{counterOffer.card?.playerName || t('trade.unknownPlayer')}</p>
          <p className="text-xs text-gray-400">{counterOffer.card?.rarity || t('trade.unknownRarity')}</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <button
          onClick={handleAcceptCounterOffer}
          disabled={processing}
          className="btn-football flex-1 bg-green-600 hover:bg-green-700"
        >
          {processing ? t('marketplaceCards.processing') : t('trade.accept')}
        </button>
        <button
          onClick={handleRejectCounterOffer}
          disabled={processing}
          className="px-6 py-3 border-2 border-red-500 text-red-300 hover:bg-red-500/20 font-semibold rounded-lg transition-all"
        >
          {t('trade.reject')}
        </button>
      </div>
    </div>
  );
};

export default CounterOfferCard;
